
import React from 'react';
import { Link } from 'react-router-dom';

function AboutSection() {
  return (
    <div className="about-us">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 order-lg-1 order-2">
            <div className="about-us-image">
              <figure className="image-anime reveal">
                <img src="/hellotruck-web-images/about-image.jpg" alt="About Hello Truck" />
              </figure>
            </div>
          </div>

          <div className="col-lg-6 order-lg-2 order-1">
            <div className="about-us-content">
              <div className="section-title">
                <h3 className="wow fadeInUp">About us</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">Welcome to <span>Hello Truck </span>, your trusted partner in seamless truck booking across Coimbatore & Tiruppur.</h2>
                <p className="wow fadeInUp" data-wow-delay="0.2s">Serving Coimbatore, Tiruppur and surrounding areas in Tamil Nadu, we understand that moving goods isn't just about transportation—it's about reliability, efficiency, and peace of mind. Whether you need local truck services, Kutty Yaanai (Tata Ace), 407 vehicle, Bolero, or load vehicles in Coimbatore and Tiruppur, or outstation transportation across Tamil Nadu, we're here to make the process simpler, faster, and more transparent for you.</p>
              </div>

              <div className="about-counter-box">
                <div className="about-counter-item">
                  <h2><span className="counter">91</span>%</h2>
                  <p>Our customer satisfaction rate stands at impressive</p>
                </div>

                <div className="about-counter-item">
                  <h2><span className="counter">1082</span>+</h2>
                  <p>Helping families and businesses to their new destinations</p>
                </div>
              </div>

              <div className="about-us-btn wow fadeInUp" data-wow-delay="0.4s">
                <Link to="/about" className="btn-default">more about us</Link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default AboutSection;
